const commentsData = [
  {
    user: '吃瓜群众甲',
    time: '2小时前',
    content: '终于找到一个能稳定访问的入口了！51版本速度很快，内容更新也及时，每天必刷。',
    likes: '326',
  },
  {
    user: '深夜追更人',
    time: '5小时前',
    content: '这条顶流塌房的消息我早就听说了，没想到在这里看到了完整时间线，细节太全了，熬夜看完！',
    likes: '258',
  },
  {
    user: '八卦雷达',
    time: '8小时前',
    content: '推荐给朋友了，91线路在移动端体验特别好，坐地铁的时候刷一刷，通勤时间过得飞快。',
    likes: '197',
  },
  {
    user: '重度爆料控',
    time: '12小时前',
    content: '对比了好几个类似的站，还是黑料吃瓜的内容最全。17版和52版换着用，基本没断过。',
    likes: '145',
  },
  {
    user: '低调围观',
    time: '1天前',
    content: '隐私保护做得确实好，HTTPS加密加上不留记录，浏览的时候心里踏实多了。良心站点。',
    likes: '112',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">读者热评</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">来自真实用户的评价与反馈</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 font-bold text-sm flex-shrink-0">
                  {item.user.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-800">{item.user}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}